const CODE_RE = /[?&]code=[^&]+/;
const STATE_RE = /[?&]state=[^&]+/;
const ERROR_RE = /[?&]error=[^&]+/;

export const hasAuthParams = (searchParams = window.location.search): boolean =>
  CODE_RE.test(searchParams) ||
  ERROR_RE.test(searchParams);

// export const hasAuthParams = (searchParams = window.location.search): boolean =>
//   (CODE_RE.test(searchParams) && STATE_RE.test(searchParams)) ||
//   ERROR_RE.test(searchParams);


// const userHasPrivilege = (authRoles: Array<string>): boolean => {
//     debugger;
//     // check user has privilege
//     let hasPrivilege = false;
//     const roles = authRoles.map((role: string) => role.toLowerCase());
//     if (state.user && state.user.privileges) {
//         for (let privilege of state.user.privileges) {
//             if (roles.indexOf(privilege.toLowerCase()) > -1) {
//                 hasPrivilege = true;
//                 break;
//             }
//         }
//     }
//
//     return hasPrivilege;
// };